import React, { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function Chute({ dark = false, alt = false, ...props }: Props) {
  const { palette }: Theme = useTheme();

  const contrastForeground = dark ? palette.secondary.lighter : palette.accent.main;
  const contrastBackground = dark ? palette.accent.main : palette.primary.dark;

  const foreground = contrastForeground;
  const background = alt ? palette.common.white : contrastBackground;

  return (
    <SvgIcon {...props} viewBox="0 0 20 23">
      <g fill="none" fillRule="evenodd">
        <path
          fill={background}
          d="M17.84 10.32c-.38.35-.88.54-1.4.55h-.04l-.6-.02-.4-.01c.12-.3.19-.64.19-1 0-1.27-.76-2.76-2.02-4-1.68-1.65-3.79-2.36-5.15-1.77l.03-.78v-.05c0-.66.2-1.18.57-1.56.6-.54 1.6-.7 2.8-.35a9.13 9.13 0 013.95 2.38c1.66 1.58 2.66 3.51 2.66 5.05 0 .66-.2 1.18-.57 1.56zm-3.59.37l-.12.12-4.27 4.17c.15-.66.23-1.37.23-2.1 0-3.1-1.41-5.58-3.3-5.9L8.2 5.6l.49-.46c.75-.51 2.53-.1 4.12 1.47 1.06 1.03 1.7 2.25 1.7 3.24 0 .37-.08.65-.26.85zm-7.29 6.94a1 1 0 01-.36.12h-.06l-.17.03h-.06c-.79-.04-1.51-.76-1.97-1.86l-.03-.03-.15-.4a7.2 7.2 0 01-.4-2V12.9c0-1.82.54-3.48 1.43-4.35.38-.37.77-.55 1.18-.55C7.8 8 9 10.23 9 12.9c0 1.8-.55 3.46-1.45 4.33-.16.17-.35.3-.57.41zm9.6-14.65A10.5 10.5 0 0012.12.3c-1.62-.46-3-.22-3.88.64a3.15 3.15 0 00-.88 2.3l-.09 1.73-2.86 2.8c-.45.43-.8.94-1.04 1.5a8.1 8.1 0 00-.7 4v.28l.01.15c.02.19.04.38.08.56v.02c0 .09.03.16.04.25v.09l.03.11.05.17c.22 1 .65 1.93 1.27 2.75.18.2.38.4.6.56l.05.05.19.13.09.05.43.2c.23.08.46.13.7.15h.16c.24 0 .48-.03.72-.1.41-.13.78-.35 1.1-.64l.05-.06.08-.06 6.22-6.08 1.19.04.62.03h.14a3.43 3.43 0 002.12-.86c.56-.57.88-1.37.88-2.31 0-1.83-1.11-3.98-2.96-5.8"
        />
        <path
          fill={foreground}
          d="M7.28 17.65l-.06.09-.06.08-.02.04-.05.07-.23.3-.05.08-.03.03-.44.59-.15.2a70.73 70.73 0 01-2.73 3.49l-.2.23-.02.03-.03.03-.08.09v.02l-.17.17-.06.04a1.4 1.4 0 01-1.12.34 1.5 1.5 0 01-1.15-.97c-.13-.35-.15-.46-.18-.55l-.05-.14v-.02a1.6 1.6 0 01-.13-.36v-.02l-.06-.3-.1-.57v-.02c-.06-.2-.07-.4-.09-.58a8 8 0 01.46-3.36l.02-.04.02-.08.02-.05v-.01l.03-.06c.07-.18.14-.36.23-.53l.13-.3.07-.11v-.04l.05-.07v-.01l.05-.08.03-.04.15-.2c.56-.79 1.2-1.56 1.88-2.26.47-.5 2.06-1.77 4.77-3.8.62.76.99 1.95 1.07 3.56.05.92-.08 1.6-.25 2.4-.25 1.18-1.06 2.17-1.21 2.36"
        />
      </g>
    </SvgIcon>
  );
}

export default memo(Chute);
